import React from 'react';
import { MessagesStatsContextProvider } from 'Context/MessagesStatsContext';
import { SimpleHouseholdProvider } from 'Context/SimpleHouseholdContext';
import { HouseholdStatsContextProvider } from 'Context/HouseholdStatsContext';
import ErrorBoundary from 'Errors/ErrorBoundary';
import App from 'App';
import { LogoutContextProvider } from 'Context/LogoutContext';
import { SwaggerlessProvider } from 'Context/SwaggerlessContext';

const MainAppRoot = () => {
  return (
    <MessagesStatsContextProvider>
      <SimpleHouseholdProvider>
        <SwaggerlessProvider>
          <LogoutContextProvider>
            <HouseholdStatsContextProvider>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </HouseholdStatsContextProvider>
          </LogoutContextProvider>
        </SwaggerlessProvider>
      </SimpleHouseholdProvider>
    </MessagesStatsContextProvider>
  );
};

export default MainAppRoot;
